import { useState } from 'react';
import { ReplyTemplateClient, ReplyTemplateDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useReplyTemplateApi = () => {
    const apiClient = new ReplyTemplateClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ReplyTemplateDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createReplyTemplate(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ReplyTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ReplyTemplateDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateReplyTemplate(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ReplyTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getReplyTemplateById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ReplyTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchReplyTemplates(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ReplyTemplates');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteReplyTemplate(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ReplyTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};